import { render, staticRenderFns } from "./TypeCard.vue?vue&type=template&id=0e132ad8&"
import script from "./TypeCard.vue?vue&type=script&lang=js&"
export * from "./TypeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports